import { ReactNode, useId } from "react";

export const getQuestionTitleId = (questionId: number | string) =>
    `question-title-${questionId}`;

type Props = {
    titleId: string;
    // Set when the user also votes for proxies: each voter gets a group named after them.
    voterName?: string;
    className?: string;
    children: ReactNode;
    "data-testid"?: string;
};

// Groups the options of a vote and names them after the question title (RGAA 11.5, 11.6).
const VoteGroup = ({ titleId, voterName, children, ...props }: Props) => {
    const voterNameId = useId();

    const labelledByIds = voterName ? `${titleId} ${voterNameId}` : titleId;
    // Hidden elements are still used to compute the accessible name.
    const hiddenVoterName = voterName ? (
        <span id={voterNameId} hidden>
            {voterName}
        </span>
    ) : null;

    return (
        <div role="group" aria-labelledby={labelledByIds} {...props}>
            {hiddenVoterName}
            {children}
        </div>
    );
};

export default VoteGroup;
